import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Button,
  Modal,
  TextField,
  MenuItem,
} from '@mui/material';
import { getEvents, createEvent } from '../../api/api';

const EventPage = () => {
  const [events, setEvents] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [newEvent, setNewEvent] = useState({
    type: '',
    description: '',
  });

  useEffect(() => {
    fetchEvents();
  }, [page, rowsPerPage]);

  const fetchEvents = async () => {
    try {
      const response = await getEvents( {
          page: page + 1, limit: rowsPerPage 
      });
      setEvents(response.data.data);
      setTotalCount(response.data.total);
    } catch (error) {
      console.error('Error fetching events:', error);
    }
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setNewEvent({ type: '', description: '' });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setNewEvent((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      await createEvent( newEvent);
      fetchEvents(); // Refresh the list
      handleClose();
    } catch (error) {
      console.error('Error creating event:', error);
    }
  };

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h4" gutterBottom>
        Events
      </Typography>
      <Button variant="contained" color="primary" onClick={handleOpen} sx={{ marginBottom: 2 }}>
        Create Event
      </Button>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Type</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Created At</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {events.map((event) => (
              <TableRow key={event._id}>
                <TableCell>{event.type}</TableCell>
                <TableCell>{event.description}</TableCell>
                <TableCell>{new Date(event.createdAt).toLocaleString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={totalCount}
          page={page}
          onPageChange={handlePageChange}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      </TableContainer>

      {/* Create Event Modal */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" gutterBottom>
            Create New Event
          </Typography>
          <TextField
            fullWidth
            select
            label="Type"
            name="type"
            value={newEvent.type}
            onChange={handleInputChange}
            sx={{ marginBottom: 2 }}
          >
            <MenuItem value="near miss collision">Near Miss Collision</MenuItem>
            <MenuItem value="collision">Collision</MenuItem>
            <MenuItem value="pedestrian">Pedestrian</MenuItem>
            <MenuItem value="signal jump">Signal Jump</MenuItem>
          </TextField>
          <TextField
            fullWidth
            label="Description"
            name="description"
            value={newEvent.description}
            onChange={handleInputChange}
            multiline
            rows={4}
            sx={{ marginBottom: 2 }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button variant="contained" color="primary" onClick={handleSubmit}>
              Submit
            </Button>
            <Button variant="outlined" color="secondary" onClick={handleClose}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default EventPage;
